<template>
  <ContentWrap>
    <el-form :inline="true" :model="query">
      <el-form-item label="用户"
        ><el-select
          v-model="query.userId"
          class="!w-160px"
          filterable
          clearable
          placeholder="请选择用户"
        >
          <el-option v-for="u in staffOptions" :key="u.value" :label="u.label" :value="u.value" />
        </el-select
      ></el-form-item>
      <el-form-item label="状态"
        ><el-select v-model="query.status" clearable class="!w-140px"
          ><el-option
            v-for="(name, index) in statusNames"
            :key="index"
            :label="name"
            :value="index" /></el-select
      ></el-form-item>
      <el-button @click="search">搜索</el-button>
    </el-form>
  </ContentWrap>
  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column prop="id" label="编号" />
      <el-table-column prop="orderId" label="订单" />
      <el-table-column prop="userId" label="用户" />
      <el-table-column prop="afterType" label="类型"
        ><template #default="scope">{{
          scope.row.afterType === 1 ? '退款' : '退货退款'
        }}</template></el-table-column
      >
      <el-table-column prop="reason" label="原因" min-width="180" />
      <el-table-column prop="refundAmount" label="退款金额" />
      <el-table-column prop="status" label="状态"
        ><template #default="scope">{{ statusNames[scope.row.status] }}</template></el-table-column
      >
      <el-table-column label="操作" width="160">
        <template #default="scope">
          <el-button
            v-if="scope.row.status === 0"
            v-hasPermi="['bosscircle:after-sale:audit']"
            link
            type="warning"
            @click="openAudit(scope.row)"
            >审核</el-button
          >
          <el-button
            v-if="scope.row.status === 1"
            v-hasPermi="['bosscircle:after-sale:complete']"
            link
            type="primary"
            @click="complete(scope.row.id)"
            >完成退款</el-button
          >
          <el-button v-if="scope.row.status !== 0" link type="primary" @click="openAudit(scope.row, true)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>

  <Dialog v-model="auditVisible" :title="audit.readonly ? '售后详情' : '售后审核'" width="640px">
    <el-descriptions :column="2" border class="mb-16px" label-width="96px">
      <el-descriptions-item label="编号">{{ audit.row?.id }}</el-descriptions-item>
      <el-descriptions-item label="订单">{{ audit.row?.orderId }}</el-descriptions-item>
      <el-descriptions-item label="用户">{{
        staffMap[audit.row?.userId] || audit.row?.userId || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="类型">{{
        audit.row?.afterType === 1 ? '退款' : '退货退款'
      }}</el-descriptions-item>
      <el-descriptions-item label="退款金额">{{ audit.row?.refundAmount ?? '-' }}</el-descriptions-item>
      <el-descriptions-item label="状态">{{
        statusNames[audit.row?.status ?? -1] || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="原因" :span="2">{{ audit.row?.reason || '-' }}</el-descriptions-item>
      <el-descriptions-item label="备注" :span="2">{{ audit.row?.remark || '-' }}</el-descriptions-item>
    </el-descriptions>
    <template v-if="!audit.readonly && audit.row?.status === 0">
      <el-divider content-position="left">审核操作</el-divider>
      <el-form label-width="96px">
        <el-form-item label="审核结果">
          <el-radio-group v-model="audit.pass">
            <el-radio :value="true">通过</el-radio>
            <el-radio :value="false">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="!audit.pass" label="拒绝原因" required>
          <el-input
            v-model="audit.remark"
            type="textarea"
            :rows="3"
            maxlength="200"
            show-word-limit
            placeholder="请填写拒绝原因"
          />
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <el-button @click="auditVisible = false">{{ audit.readonly ? '关闭' : '取消' }}</el-button>
      <el-button
        v-if="!audit.readonly && audit.row?.status === 0"
        type="primary"
        :loading="audit.saving"
        @click="submitAudit"
        >提交审核</el-button
      >
    </template>
  </Dialog>
</template>
<script setup lang="ts">
import * as Api from '@/api/business/afterSale'
defineOptions({ name: 'BossCircleAfterSale' })
const { staffOptions, staffMap, loadStaffs } = useStaff()
const message = useMessage()
const statusNames = ['待审核', '已通过', '已拒绝', '已完成']
const loading = ref(false),
  list = ref<any[]>([]),
  total = ref(0)
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  userId: undefined as number | undefined,
  status: undefined as number | undefined
})
const auditVisible = ref(false)
const audit = reactive({
  row: undefined as any,
  pass: true,
  remark: '',
  saving: false,
  readonly: false
})
const load = async () => {
  loading.value = true
  try {
    const data = await Api.getAfterSalePage(query)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}
const search = () => {
  query.pageNo = 1
  load()
}
const openAudit = (row: any, readonly = false) => {
  audit.row = row
  audit.pass = true
  audit.remark = ''
  audit.readonly = readonly || row.status !== 0
  auditVisible.value = true
}
const submitAudit = async () => {
  if (!audit.row?.id) return
  if (!audit.pass && !audit.remark.trim()) {
    message.warning('请填写拒绝原因')
    return
  }
  audit.saving = true
  try {
    await Api.auditAfterSale({
      id: audit.row.id,
      status: audit.pass ? 1 : 2,
      remark: audit.pass ? '' : audit.remark.trim()
    })
    message.success('审核完成')
    auditVisible.value = false
    load()
  } finally {
    audit.saving = false
  }
}
const complete = async (id: number) => {
  await message.confirm('确认完成退款并恢复库存？')
  await Api.completeAfterSale(id)
  message.success('处理完成')
  load()
}
onMounted(() => {
  loadStaffs()
  load()
})
</script>
